export const profile = (state) => {
    return state.profile;
};

export const general = (state) => {
    return state.profile.general.metas[0].value;
};

export const avatar = (state) => {
    return state.profile.avatar;
}

export const age = (state) => {
    return state.profile.age;
};

export const contacts = (state) => {
    return state.profile.contacts.metas[0].value;
};

export const parents = (state) => {
    return !! state.profile.parents ? state.profile.parents.metas.map(meta => {
        return {
            id: meta.id,
            ...meta.value
        }
    }) : null;
};

export const ncsaProfile = (state) => {
    return state.profile.ncsa_profile ? state.profile.ncsa_profile.metas.map(meta => {
        return {
            id: meta.id,
            ...meta.value
        }
    }) : null;
};

export const tempNcsaProfile = (state) => {
    return state.tempNcsaProfile;
}

export const levelOfPlay = (state) => {
    return state.profile.level_of_play;

}

export const optInFromPublish = (state) => {
    return state.opt_in_from_publish;
}

export const restrictedLevelOfPlay = (state) => {
    return state.profile.restricted_level_of_play;
}

export const allowedLevelOfPlay = (state) => {
    return state.profile.allowed_level_of_play;
}

export const academy = (state) => {
    return state.profile.academy ? state.profile.academy.metas[0].value : null;
};

export const video = (state) => {
    return state.profile.videos;
};

export const bio = (state) => {
    return state.profile.bio;
};

export const educations = (state) => {
    return state.profile.educations.map(education => education.metas[0].value);
};

export const teams = (state) => {
    return state.profile.teams;
};

export const additionalSports = (state) => {
    return state.profile.additional_sports;
};

export const statsAthletics = (state) => {
    return state.profile.stats.athletics;
};

export const statsPerformances = (state) => {
   return state.profile.stats.performances;
};

export const roles = (state) => {
    return state.profile.roles;
};

export const user = (state) => {
    return state.user;
};

export const errors = (state) => {
    return state.errors;
};

export const message = (state) => {
    return state.message;
}

export const modal = (state) => {
    return state.modal;
};

export const modals = (state) => {
    return state.modals;
};

export const sessions = (state) => {
    return state.sessions;
};

export const actions = (state) => {
    return state.actions;
};

export const puttActions = (state) => {
    return state.puttActions;
};

export const swingActions = (state) => {
    return state.swingActions;
};

export const profileActions= (state) => {
    return state.profile.actions;
};

export const videos = (state) => {
    return state.videos;
};

export const selectedVideos = (state) => {
  return state.selectedVideos;
};

export const profileVideos = (state) => {
    return state.profile.videos.data;
};

export const profileVideosID = (state) => {
    return state.profile.videos.id;
};

export const showcases = (state) => {
    return state.profile.showcases;
};

export const tournaments = (state) => {
    return state.profile.tournaments;
};

export const deleteMessage = (state) => {
    return state.delete_message;
};

export const nextModal = (state) => {
    return state.next_modal;
};

export const deleteID = (state) => {
    return state.delete_id;
};

export const settings = (state) => {
    return state.settings;
};

export const ncsaMinimizeBanner = (state) => {
    return state.profile.ncsa_meta.disable_full_ncsa_banner;
}

export const slug = (state) => {
    return state.profile.settings.slug;
}
